<template>
  <eco-labeled-control :context="contextV2" :attributes="attributes" class="consumption-validation-control">
    <v-tooltip bottom>
      <base-checkbox slot="activator" 
        :value="device.consumptionValidationEnabled"
        :disabled="isInteracted"
        @buttonToggled="onChecked"
      />
      <span>{{ 'parameter.consumptionvalidation' | translate }}</span>
    </v-tooltip>
  </eco-labeled-control>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import { DeviceModel, SetDeviceConsumptionValidationEnabledInput } from '../../../../../../../eco-domain-store-modules/src/plcOperation/models'

import { EcoLabeledControl } from '@ecocoach/shared-components/src'
import { BaseControlAttributes, ControlContextV2 } from '@ecocoach/shared-components/src/components/deviceControls/v2/models'

const Resource = namespace('resource')
const ParametrizationUi = namespace('parametrizationUi')

@Component({
  components: {
    EcoLabeledControl,
  },
})
export default class ConsumptionValidationEnabled extends Vue {
  @Prop() public device: DeviceModel
  @Resource.Getter public dictionary
  @ParametrizationUi.Getter public isInteracted: boolean
  @ParametrizationUi.Action public setDeviceConsumptionValidationEnabled: (input: SetDeviceConsumptionValidationEnabledInput) => Promise<void>

  public get contextV2(): ControlContextV2 {
    return {
      resolveStringResource: (resourceKey: string): string => {
        return this.dictionary(resourceKey)
      },
    } as ControlContextV2
  }

  public get attributes() {
    return {
      label: 'parameter.consumptionvalidation',
      tooltip: 'common.consumptionvalidation.label',
    } as BaseControlAttributes
  }

  public onChecked(enabled: string) {
    this.setDeviceConsumptionValidationEnabled({
      deviceId: this.device.id,
      consumptionValidationEnabled: !enabled,
    } as SetDeviceConsumptionValidationEnabledInput)
  }
}
</script>
<style lang="scss" scoped>
.consumption-validation-control {
  padding-bottom: 15px;
}
</style>
